import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Timeline.css';

const TimelineData = [
  {
    year: '2000–2018',
    heading: 'Childhood & Early Interests',
    emoji: '🧩',
    content: (
      <p>
        Born and raised in Algeria — I was the quiet kid, I loved math, chemistry, and English,
        and spent weekends crafting handmade items.
      </p>
    ),
  },
  {
    year: '2019–2022',
    heading: 'University & First Book',
    emoji: '💻',
    content: (
      <>
        <p>
          Studied Computer Science — Information Systems. Built websites, software, and mobile
          apps. My bachelor's thesis sparked an interest in UX/UI design. Graduated in 2022.
        </p>
        <p>
          That same year, I published my first book, <em>Before we Get Older</em> — a personal
          reflection on life lessons I collected growing up.
        </p>
      </>
    ),
  },
  {
    year: '2022–2024',
    heading: "Master's, AI & Prospera",
    emoji: '🎓',
    content: (
      <>
        <p>
          Master's in Big Data Management & Analysis — ML, Data Science, and optimization. My
          thesis was about water distribution networks optimization using Genetic Algorithms and SQP, integrated
          with the Flowmax hydraulic simulation tool.
        </p>
        <p>
          Submitted <strong>Prospera</strong> to Google's Women Techmakers "She Builds AI"
          Hackathon — awarded <em>Best in Gender Equality</em>.
        </p>
        <div className="tl-embed">
          <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/eeTv_fCXkmw"
            title="Prospera Demo"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </>
    ),
  },
  {
    year: '2025',
    heading: 'TEDx & AppWhiz',
    emoji: '🎤',
    content: (
      <>
        <p>
          Joined the organizing team of <strong>TEDxBoumerdes</strong> as part of the Content &
          Media committee — curating ideas and working behind the scenes to bring a meaningful
          event to life in our community.
        </p>
        <p>
          Created <strong>AppWhiz</strong>, an AI-powered guessing game, for the Perplexity AI
          Hackathon. Built around smart prompting and instant feedback.
        </p>
        <div className="tl-embed">
          <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/fzAtj5TnM0M"
            title="AppWhiz Demo"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </>
    ),
  },
 {
  year: "2026–Now",
  heading: "What I'm Doing Now",
  emoji: null,
  isLive: true,
  content: (
    <>
      <p className="tl-updated">Updated 13 September, 2026</p>
      <ul>
        <li>Working full-time as a mobile developer</li>
        <li>Tweaking this website</li>
        <li>Marketing my books — open to collaborations, reach out!</li>
        <li>Current favorite song: Djo - End Of Beginning</li>
      </ul>
    </>
  ),
},
];

function Timeline() {
  useEffect(() => {
    AOS.init({ duration: 800, easing: 'ease-out', once: true });
  }, []);

  return (
    <section className="Timeline-section">
      <h2 className="Timeline-title" data-aos="fade-up">
        My Journey
      </h2>

      <div className="tl-track">
        {TimelineData.map((item, index) => (
          <>
            {item.isLive && <hr key={`divider-${index}`} className="tl-divider-line" />}

            <div
              key={`year-${index}`}
              className={`tl-year-col${item.isLive ? ' live' : ''}`}
              data-aos="fade-right"
              data-aos-delay={index * 100}
            >
              {item.year}
            </div>

            <div key={`dot-${index}`} className="tl-dot-col">
              <div className={`tl-dot${item.isLive ? ' live' : ''}`} />
            </div>

            <div
              key={`card-${index}`}
              className="tl-card-col"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="tl-card">
                <div className="tl-card-body">
                  <p className="tl-heading">{item.heading}</p>
                  <div className="tl-body">{item.content}</div>
                </div>
                {item.emoji && (
                  <span className="tl-icon" aria-hidden="true">{item.emoji}</span>
                )}
              </div>
            </div>
          </>
        ))}
      </div>
    </section>
  );
}

export default Timeline;